<tui-island>
  <div class="flex gap-x-2">
    <div class="w-3/4 border-r border-gray-300 border-solid">
      <h2 class="font-bold text-sm mb-2">Сортировка</h2>
      <div class="flex flex-wrap gap-2 mb-2">
        @for (field of notSelectedFields$ | async; track field.value) {
          <button
            (click)="commonStateService.selectSortingField(field)"
            appearance="outline"
            tuiButton
            size="s"
          >
            {{ field.name }}
          </button>
        } @empty {
          <span class="text-sm py-2">Нет доступных полей для сортировки</span>
        }
      </div>
      <div class="flex flex-wrap gap-2 mb-2">
        @for (
          field of commonStateService.selectedSortingFields$ | async;
          track field.value
        ) {
          <button
            (click)="commonStateService.selectSortingField(field)"
            appearance="secondary"
            tuiButton
            size="s"
          >
            {{ field.name }} <tui-svg src="tuiIconClose"></tui-svg>
          </button>
        }
      </div>
    </div>
    <div class="w-1/4 px-2">
      <h2 class="font-bold text-sm mb-2">Фильтр</h2>
      <tui-input-number
        class="w-[100px]"
        tuiTextfieldSize="m"
        [formControl]="commonStateService.weekNumber"
        [precision]="0"
        >Неделя</tui-input-number
      >
    </div>
  </div>
</tui-island>
